import API from "../configs/axiosInstance";

const createDomain = (data = {}) => {
    return API({
        url: `/account-service/v1/domains/save-list`,
        method: 'POST',
        data
    });
};

const createIps = (data = {}) => {
    return API({
        url: `/account-service/v1/domains/ips`,
        method: 'POST',
        data
    });
};

const getDomainsFiltered = (params = {}, data = {}) => {
    return API({
        url: `/account-service/v1/domains/pageable`,
        method: 'POST',
        data,
        params
    });
}

const deleteDomain = (data) => {
    return API({
        url: `/account-service/v1/domains/${data}`,
        method: 'DELETE',
        data
    });
}

const deleteDomains = (ids) => {
    return API({
        method: 'DELETE',
        url: `/account-service/v1/domains/all`,
        data: ids,
        headers: {
            'Content-Type': 'application/json'
        }
    });
};

const downloadFileDomain = (data) => {
    return API({
        url: `/account-service/v1/pdf-templates/pdf/${data.id}`,
        method: 'POST',
        responseType: 'arraybuffer',
        data
    });
}

const triggerDomainScan = id => {
    return API({
        url: `/account-service/v1/domains/${id}/scan-trigger`,
        method: 'POST',
        responseType: 'arraybuffer'
    });
}

const getHistory = (data = {}, params = {}) => {
    return API({
        url: '/account-service/v1/domains/all-history',
        method: 'POST',
        data,
        params
    })
}

const getDomainCount = () => {
    return API({
        url: '/account-service/v1/domains/count?type=DOMAIN',
    })
}

const getSubDomainCount = () => {
    return API({
        url: '/account-service/v1/domains/count?type=SUB_DOMAIN',
    })
}

const getIpCount = () => {
    return API({
        url: '/account-service/v1/domains/count?type=IP',
    })
}

const getCriticalLevelsByDomain = (data) => {
    return API({
        url: `/issue-service/v1/tasks/domain-critical-level-count?domainId=${data}`,
    })
}

const getDetailSubDomains = (data) => {
    return API({
        url: `/account-service/v1/domains/pageable`,
        method: 'POST',
        ...data
    })
}

const getDetailIps = (data) => {
    return API({
        url: `/account-service/v1/domains/pageable`,
        method: 'POST',
        ...data
    })
}

const getDomainIssues = (data) => {
    return API({
        url: `/issue-service/v1/tasks/by-domain`,
        method: 'POST',
        ...data
    })
}

const sendBackIssue = (data) => {
    return API({
        url: `/issue-service/v1/tasks/send-back`,
        method: 'PUT',
        data
    })
}

const getAllDomains = (data = {}) => {
    return API({
        url: `/account-service/v1/domains/search`,
        method: 'POST',
        data
    });
}

const getStatus = (data = {}) => {
    return API({
        url: `/account-service/v1/domains/${data}/scan-status`,
        method: 'GET',
        data
    });
}

const getScheduleStatus = (data) => {
    return API({
        url: `/account-service/v1/domains/${data}/is-scan-enabled`,
        method: 'GET',
    });
}

const startAssetSchedule = (data) => {
    return API({
        url: `/account-service/v1/domains/${data}/enable-schedule-scan`,
        method: 'PUT',
    });
}

const stopAssetSchedule = (data) => {
    return API({
        url: `/account-service/v1/domains/${data}/disable-schedule-scan`,
        method: 'PUT',
    });
}


const domainService = {
    createDomain,
    createIps,
    getDomainsFiltered,
    deleteDomain,
    downloadFileDomain,
    getHistory,
    triggerDomainScan,
    getDomainCount,
    getSubDomainCount,
    getIpCount,
    getCriticalLevelsByDomain,
    getDetailSubDomains,
    getDetailIps,
    getDomainIssues,
    getAllDomains,
    getStatus,
    getScheduleStatus,
    startAssetSchedule,
    stopAssetSchedule,
    sendBackIssue,
    deleteDomains
};

export default domainService;
